module.exports = __webpack_public_path__ + "static/media/capital_trabajo1.b15a5358.jpg";